export default {
  root: "im-page-header",
};
